import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import routes from './config/settings/routes'
import NotFoundPage from './pages/NotFound'
import QuoteRequestPublishedSuccessfullyPage from './pages/QuoteRequestPublishedSuccessfully'
import QuoteProvidersListPage from './pages/QuoteProvidersList'
import QuoteSellerBidPage from './pages/QuoteSellerBid'
import QuoteSearchPage from './pages/QuoteSearch'
import QuoteStepOnePage from './pages/QuoteStepOne'
import QuoteStepTwoPage from './pages/QuoteStepTwo'
import QuoteSummaryPage from './pages/QuoteSummary'
import SearchGoodsAndServicesPage from './pages/SearchGoodsAndServices'
import SellerQuotePublishedSuccessfullyPage from './pages/SellerQuotePublishedSuccessfully'
import StatusPurchaseOrderPage from './pages/StatusPurchaseOrder'

import ScrollToTop from './components/Custom/ScrollToTop'

/**
 * The Routing's component.
 */
const Routing = () => (
  <BrowserRouter>
    <ScrollToTop />

    <Routes>
      <Route caseSensitive element={<QuoteSearchPage />} path={routes.root} />
      <Route caseSensitive element={<QuoteSearchPage />} path={routes.search} />
      <Route caseSensitive element={<QuoteStepOnePage />} path={routes.quoteStepOne} />
      <Route caseSensitive element={<QuoteStepTwoPage />} path={routes.quoteStepTwo} />
      <Route caseSensitive element={<QuoteProvidersListPage />} path={routes.quoteProvidersList} />
      <Route caseSensitive element={<SearchGoodsAndServicesPage />} path={routes.searchGoodsAndServices} />
      <Route
        caseSensitive
        element={<QuoteRequestPublishedSuccessfullyPage />}
        path={routes.quoteRequestPublishedSuccessfully}
      />
      <Route caseSensitive element={<QuoteSellerBidPage />} path={routes.quoteSellerBid} />
      <Route
        caseSensitive
        element={<SellerQuotePublishedSuccessfullyPage />}
        path={routes.sellerQuotePublishedSuccessfully}
      />
      <Route caseSensitive element={<QuoteSummaryPage />} path={routes.quoteSummary} />
      <Route caseSensitive element={<StatusPurchaseOrderPage />} path={routes.purchaseOrderStatus} />
      <Route element={<NotFoundPage />} path="*" />
    </Routes>
  </BrowserRouter>
)

export default Routing
